<template>
  <main class="mt-2 pb-40">
    <!-- Trigger Section -->
    <section class="grid gap-3">
      <div>
        <p class="label-text-medium">Bank Statement</p>
        <p class="secondary-heading-text">Here are the documents you’ve uploaded. You can review or remove them if needed.</p>
      </div>
      <span class="grid gap-3" v-if="uploadedDocuments?.length > 0">
        <div v-for="(data, index) in uploadedDocuments" :key="index">
          <div class="w-full p-4 rounded-lg bg-white shadow-cardShadow">
            <div class="flex items-center justify-between gap-20">
              <!-- File Details Section -->
              <div @click.prevent="previewFile(data)" class="flex items-center gap-3 cursor-pointer">
                <div class="w-8 h-8">
                  <img class="w-8 h-8" src="../assets/upload-manually.svg" alt="upload">
                </div>
                <div>
                  <p class="label-text-medium text-primary whitespace-nowrap truncate w-24">{{ data.originalFileName }}</p>
                </div>
              </div>
              <!-- Preview Action Section -->
                <button
                  type="button"
                  class="secondary-headingColor-text-blogger font-semibold text-primary underline"
                  @click.prevent="selectBank =data, isPanelBankRejectOpen= true"
                >
                  Remove
                </button>
            </div>
          </div>
        </div>
      </span>
    </section>
    <section class="footer flex gap-4">
      <custom-button
        @click.prevent="requestMedia('Add More')"
        variant="transparentPrimary"
        class="bg-white w-full"
      >
        Add More
      </custom-button>
      <custom-button
        @click.prevent="handleDocActionSubmit()"
        variant="primary"
        class="w-full"
      >
      <p class="grid text-base">
        Submit
      </p>
      </custom-button>
    </section>
    <transition name="fade">
      <router-view v-slot="{ Component }">
        <sidebar
          :isPanelOpen="$route.meta.showSidebar"
          @closeSidebarPanel="closePreview($route.query.name)"
          position="bottom"
          paddingTopBottom="paddingTopBottomHide"
          :panelHeight="customPanelHeight"
        >
          <section
            class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4"
          >
            <div @click.prevent="closePreview($route.query.name)" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
            <h2 class="heading-text">{{ $route.query.name }}</h2>
          </section>
          <div class="grid gap-4">
            <component :is="Component" />
          </div>
        </sidebar>
      </router-view>
    </transition>
    <!-- Password Protected Section -->
    <router-view>
      <sidebar
        :isPanelOpen="isPanelOpen"
        @closeSidebarPanel="false"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section
          class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4"
        >
          <div @click.prevent="false" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
          <h2 class="heading-text">Bank Statement</h2>
        </section>
        <div class="grid gap-4">
          <form @submit.prevent="pdfPasswordFun()">
            <section class="grid gap-6 px-4 py-4">
                <article class="flex justify-between pr-4 h-16 items-center rounded-lg shadow-cardShadow w-full bg-white">
                  <div class="flex items-center">
                    <div class="w-16 h-16">
                      <Vue3Lottie :animationData="AutoTick" :speed="1" :loop="true" />
                    </div>
                    <span>
                      <p class="label-text-medium whitespace-nowrap truncate w-32">{{ storagePdf?.name }}</p>
                      <p class="secondary-heading-text-blogger">File Uploaded</p>
                    </span>
                  </div>
                  <div>
                    <p @click.prevent="removePdf()" class="underline font-blogger text-xs text-primary font-semibold cursor-pointer">
                      Remove
                    </p>
                  </div>
                </article>
                <article class="grid gap-2">
                    <p class="label-text-medium">Password</p>
                    <input
                      type="text"
                      name="password"
                      id="password"
                      class="input rounded-lg shadow-cardShadow"
                      placeholder="Enter Password"
                      v-model="pdfPasswordValue"
                      required
                    />
                    <p class="secondary-heading-text">
                        This PDF is password-protected. Please enter the password below to upload and continue.
                    </p>
                </article>
            </section>
            <section class="grid py-8 px-4">
              <custom-button
                type="submit"
                variant="primary"
                arrowAnimation
              >
                Submit
              </custom-button>
            </section>
          </form>
        </div>
      </sidebar>
    </router-view>
    <!-- Bank Document Reject -->
    <router-view>
      <sidebar
        :isPanelOpen="isPanelBankRejectOpen"
        @closeSidebarPanel="isPanelBankRejectOpen = false"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section
          class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4"
        >
          <div @click.prevent="isPanelBankRejectOpen = false" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
          <h2 class="heading-text">Remove Bank statement</h2>
        </section>
        <div class="grid gap-4">
          <form @submit.prevent="discardBankDocument()">
            <section class="grid justify-items-center gap-6 py-4">
              <img class="w-40 h-40" src="../assets/no-bank-statement.svg" alt="doc img">
              <p class="label-text-normal text-center w-72">
                Are you sure you want to remove <span class="font-semibold">{{ selectBank.originalFileName }}</span> bank statement?
              </p>
            </section>
            <section class="flex gap-4 py-8 px-4">
              <custom-button
                @click.prevent="isPanelBankRejectOpen = false"
                type="submit"
                variant="transparentPrimary"
                class="w-full"
              >
                No
              </custom-button>
              <custom-button
                type="submit"
                variant="primary"
                class="w-full"
              >
                Yes
              </custom-button>
            </section>
          </form>
        </div>
      </sidebar>
    </router-view>
    <!-- Confirm Glib Api -->
    <router-view>
      <sidebar
        :isPanelOpen="isPanelGlibConfirm"
        @closeSidebarPanel="isPanelGlibConfirm = false"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section
          class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4"
        >
          <div @click.prevent="isPanelGlibConfirm = false" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
          <h2 class="heading-text">Double-check your statement</h2>
        </section>
        <div class="grid gap-4">
          <form @submit.prevent="postGlibUploadBankStatement()">
            <section class="grid justify-items-center gap-6 py-4">
              <img class="w-40 h-40" src="../assets/double-bank-statement.svg" alt="doc img">
              <p class="label-text-normal text-center w-72">
                Are you sure this bank statement covers at least last 6 months? Uploading an incomplete statement my cause delays.
              </p>
            </section>
            <section class="flex gap-4 py-8 px-4">
              <custom-button
                @click.prevent="reUploadFun()"
                type="submit"
                variant="transparentPrimary"
                class="w-full"
              >
                Re-Upload
              </custom-button>
              <custom-button
                type="submit"
                variant="primary"
                class="w-full"
              >
                Yes, Continue
              </custom-button>
            </section>
          </form>
        </div>
      </sidebar>
    </router-view>
    <!-- If it’s Not a 6-Month Bank Statement -->
    <router-view>
      <sidebar
        :isPanelOpen="isPanelNotSixMonthBank"
        @closeSidebarPanel="false"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section
          class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4"
        >
          <div @click.prevent="false" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
          <h2 v-if="notValidBankStatement" class="heading-text">Bank Statement Not Valid</h2>
          <h2 v-else class="heading-text">Double-check your statement</h2>
        </section>
        <div class="grid gap-4">
          <form>
            <section v-if="notValidBankStatement" class="grid justify-items-center gap-6 py-4">
              <img class="w-40 h-40" src="../assets/no-bank-statement.svg" alt="doc img">
              <p class="label-text-normal text-center w-72">
                Verification failed. Please re-upload your bank statement or try Instant Verification.
              </p>
            </section>
            <section v-else class="grid justify-items-center gap-6 py-4">
              <img class="w-40 h-40" src="../assets/double-bank-statement.svg" alt="doc img">
              <p class="label-text-normal text-center w-72">
                The uploaded bank statement doesn't cover 6 months. Please upload at least 6-month statement to continue.
              </p>
            </section>
            <section class="flex gap-4 py-8 px-4">
              <custom-button
                @click.prevent="requestMedia('Re-Upload', 'bank statement not cover 6 months')"
                variant="transparentPrimary"
                class="w-full"
              >
                Re-Upload
              </custom-button>
              <custom-button
                variant="primary"
                class="w-full"
                @click.prevent="getInstantVerification()"
              >
                Instant Verify
              </custom-button>
            </section>
          </form>
        </div>
      </sidebar>
    </router-view>
    <!-- Bank Statement under review -->
    <router-view>
      <sidebar
        :isPanelOpen="isPanelBankStatementUnderReview"
        @closeSidebarPanel="false"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section
          class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4"
        >
          <div title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
          <h2 class="heading-text">Bank statement</h2>
        </section>
        <div class="grid gap-4">
          <form @submit.prevent="getInstantVerification()">
            <section class="grid justify-items-center gap-6 py-4">
              <img class="w-40 h-40" src="../assets/double-bank-statement.svg" alt="doc img">
              <p class="label-text-normal text-center w-72">
                Bank statement review is in progress. Choose Instant Verification for quicker and improved loan offers.
              </p>
            </section>
            <section class="flex gap-4 py-8 px-4">
              <custom-button
                @click.prevent="reviewNoBankStatementFun()"
                type="submit"
                variant="transparentPrimary"
                class="w-full"
              >
                No
              </custom-button>
              <custom-button
                type="submit"
                variant="primary"
                class="w-full"
              >
                Yes
              </custom-button>
            </section>
          </form>
        </div>
      </sidebar>
    </router-view>
    <!-- Spin Loader -->
    <spin-loader :spinLoading="isSpinLoading"/>
    <!-- Spin Loan Offer Loader -->
    <spin-loader :dynamicMsg="true" :textSpinner="''" :subTextSpinner="textSpinnerText" :spinLoading="isSpinLoadingLoanOffer"/>
  </main>
</template>

  <script>
  import { mapGetters } from 'vuex';
  import { toRaw, isRef } from 'vue';
  import Sidebar from '../components/Sidebar.vue';
  import SpinLoader from '../components/spinLoader.vue';
  import CustomButton from '../components/CustomButton.vue';
  import AutoTick from '../assets/animation/auto-tick.json';

  export default {
    name: "ShowBankStatement",
    components: {
      SpinLoader,
      CustomButton,
      Sidebar
    },
    data() {
      return {
        pageVisible: undefined,
        customPanelHeight: 'auto',
        isSpinLoading: undefined,
        uploadedDocuments: [],
        AutoTick,
        pdfPasswordValue: undefined,
        storagePdf: undefined,
        isPanelOpen: false,
        isPanelBankRejectOpen: false,
        selectBank: null,
        isPanelGlibConfirm: false,
        glibUploadedDoc: [],
        isPanelNotSixMonthBank: false,
        notValidBankStatement: false,
        isSpinLoadingLoanOffer: undefined,
        textSpinnerText: "We’re processing your request",
        isNotSixHide: false,
        checkStatusInterval: null,
        isPanelBankStatementUnderReview: false,
      };
    },
    computed: {
      ...mapGetters(['applicationId', 'bankStatementStatusData']),
      checKDocLength() {
        const ids = this.uploadedDocuments?.map(item => item.id) || [];
        const glib = this.unWrapProxy(this.glibUploadedDoc);
        if (ids.length === 0) {
          return true;
        }
        const result = ids.every(val => glib.includes(val));
        return result;
      }
    },
    mounted() {
      this.init();
    },
  beforeUnmount() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    init() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MANUAL_BANK_STATEMENT_LIST_LANDED, {
        [this.$mixpanelPayload.KEY_MESSAGE]: this.$route?.query,
      });
      if (this.$route.query.invalidBankStatement === 'true') {
        this.isPanelNotSixMonthBank = true;
        this.notValidBankStatement = true;
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MANUAL_POPUPS, {
          [this.$mixpanelPayload.KEY_MESSAGE]: 'Verification failed.',
        });
      } else if (this.$route.query.hasRequiredMonthsBankStatement === 'false' && this.$route.query.processingType === "manual") {
        this.isPanelNotSixMonthBank = true;
        this.notValidBankStatement = false;
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MANUAL_POPUPS, {
          [this.$mixpanelPayload.KEY_MESSAGE]: 'bank statement doesnt cover 6 months',
        });
      } else {
        this.requestMedia();
      }
    },
    previewFile(data) {
      if (data) {
        this.$router.push({
          name: 'Preview Statements',
          query: {
            name: 'Bank Statement',
            id: data.id,
            contentType: data.contentType,
            docName: data.name || 'bank statement',
          },
        });
      }
    },
    backToStep3() {
      this.$router.push({
        name: 'Pre Approval Step 3',
      });
    },
    getApplicationProfile() {
      this.isSpinLoading = true;
      this.$store
        .dispatch('applicationProfile', { applicationId: this.applicationId })
        .then((result) => {
          this.glibUploadedDoc = result?.uploadedBankStatementDocumentIds;
          const bankStatementProofs = result?.documents?.filter(
              (document) => document.docType === 'bank_statement' && document.docSubType === 'not_applicable'
            ) || undefined;
          if (bankStatementProofs?.length > 0) {
            this.getBankStatementStatus();
          } else {
            this.backToStep3();
          }
          this.uploadedDocuments = bankStatementProofs;
          this.isSpinLoading = false;
        })
        .catch(() => {
          this.isSpinLoading = false;
        });
    },
    getBankStatementStatus(check) {
      if (check !== 'interval') {
        this.isSpinLoading = true;
      }
      this.$store
        .dispatch('bankStatementStatus', {
          applicationId: this.applicationId,
        })
        .then((res) => {
          this.statusData = res;
          if (res.hasRequiredMonthsBankStatement === 'true' || (res?.hasRequiredMonthsBankStatement === '' && res?.processingType === 'manual')) {
            this.$store.commit('SET_IS_BANK_STATEMENT_DOC_UPLOADED', true);
          }
          this.isSpinLoading = false;
        })
        .catch(() => { this.isSpinLoading = false; });
    },
    closePreview(value) {
      if (value === 'Bank Statement') {
        this.$router.push({
          name: 'Show Bank Statement',
        });
      } else {
          this.$router.push({
          name: 'Pre Approval Step 3',
        });
      }
    },
    // password protected methods
    requestMedia(check, msg) {
      if (check === 'Add More') {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MANUAL_ADD_MORE_BTN_CLICKED);
      } else if (check === 'Re-Upload') {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MANUAL_REUPLOAD_BTN_CLICKED, {
          [this.$mixpanelPayload.KEY_MESSAGE]: msg,
        });
      }
      const mediaRequest = {
        allowedMimeTypes: ["application/pdf"],
      };
      window.microapps.requestMedia(mediaRequest).then(response => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_REQUEST_MEDIA, {
          [this.$mixpanelPayload.RESPONSE]: 'success',
          [this.$mixpanelPayload.KEY_MESSAGE]: 'manual upload bank statement list component',
        });
        const fileByteArray = this.base64ToByteArray(response.bytes);
        const blob = new Blob([fileByteArray], { type: response.mimeType });
        this.openFilePicker(blob);
      })
      .catch((err) => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_REQUEST_MEDIA, {
          [this.$mixpanelPayload.RESPONSE]: err,
          [this.$mixpanelPayload.KEY_MESSAGE]: 'manual upload bank statement list component',
        });
        if (this.isNotSixHide) {
          this.isPanelNotSixMonthBank = true;
        }
        if (!this.isPanelNotSixMonthBank) {
          this.getApplicationProfile();
        }
      });
    },
    base64ToByteArray(base64String) {
      const binaryString = window.atob(base64String);
      const byteArray = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i += 1) {
          byteArray[i] = binaryString.charCodeAt(i);
      }
      return byteArray;
    },
    getFileExtension(blob) {
      const splitName = blob.type.split('/');
      return splitName[splitName.length - 1];
    },
    async openFilePicker(blob) {
      const fileExtension = this.getFileExtension(blob);
      const timestamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\..*$/, '');
      const fileName = `bank_statement_${timestamp}.${fileExtension}`;
      // Create a File object multipart
      const multipartFile = new File([blob], fileName, {
        lastModified: Date.now(),
        type: blob.type,
      });
      this.storagePdf = multipartFile;
      const locked = await this.$store.dispatch("checkPdfPasswordProtected", multipartFile);
      if (locked) {
        this.isSpinLoading = false;
        if (this.isPanelNotSixMonthBank) {
          this.isPanelNotSixMonthBank = false;
          this.isNotSixHide = true;
        }
        this.isPanelOpen = true;
      } else {
        this.isPanelOpen = false;
        this.uploadBankStatement(multipartFile);
      }
    },
    uploadBankStatement(multiFile) {
      this.isSpinLoading = true;
      const formData = new FormData();
      formData.append('files', multiFile);
      this.$store
        .dispatch('applicationBankStatement', {
          formData,
          applicationId: this.applicationId,
          urlParams: {
            review: true,
          }
        })
        .then(() => {
          this.$moshaToast('Bank statement added successfully.', {
            type: "success",
            showIcon: true,
          });
          this.isSpinLoading = false;
          this.closeUnlockPDoc();
        })
        .catch(() => {
          this.isSpinLoading = false;
        });
    },
    pdfPasswordFun() {
      this.isSpinLoading = true;
      this.$store.dispatch("unlockPdfWithPassword", {
        file: this.storagePdf,
        password: this.pdfPasswordValue,
      })
      .then(({ unlockedFile }) => {
        this.isSpinLoading = true;
        this.uploadBankStatement(unlockedFile);
      })
      .catch((err) => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_PASSWORD_PDF_ERROR, {
          [this.$mixpanelPayload.RESPONSE]: err,
          [this.$mixpanelPayload.KEY_MESSAGE]: 'Password protected PDF error in bank statement upload',
        });
        this.isSpinLoading = false;
        this.$moshaToast(err.message, {
          type: "danger",
          showIcon: true,
        });
      });
    },
    closeUnlockPDoc() {
      this.isPanelOpen = false;
      this.pdfPasswordValue = undefined;
      this.storagePdf = undefined;
      this.selectBank = null;
      this.isPanelBankRejectOpen = false;
      this.isPanelNotSixMonthBank = false;
      this.notValidBankStatement = false;
      this.isPanelGlibConfirm = false;
      this.isNotSixHide = false;
      this.getApplicationProfile();
    },
    removePdf() {
      this.isPanelOpen = false;
      this.pdfPasswordValue = undefined;
      this.storagePdf = undefined;
      this.requestMedia();
    },
    discardBankDocument() {
      this.isSpinLoading = true;
      this.$store.dispatch("applicationDiscardDocument", {
        docId: this.selectBank.id,
      })
      .then(() => {
        this.$moshaToast('Bank statement removed successfully.', {
          type: "success",
          showIcon: true,
        });
        this.isSpinLoading = true;
        this.closeUnlockPDoc();
      })
      .catch(() => {
        this.isSpinLoading = false;
      });
    },
    postGlibUploadBankStatement() {
      const ids = this.uploadedDocuments?.map(item => item.id);
      this.isSpinLoading = true;
      const rowData = {
        documentIds: ids
      };
      this.$store
        .dispatch('glibUploadBankStatement', {
          rowData,
          applicationId: this.applicationId
        })
        .then(() => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_GLIB_UPLOAD_BANK_STATEMENT, {
            [this.$mixpanelPayload.RESPONSE]: 'success',
          });
          this.getBankStatementStatusRetry();
          this.isSpinLoading = false;
          // how to implement the logic need to discuss interval status logic ever 30 seconds
          // this.startBankStatementPolling();
        })
        .catch((err) => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_GLIB_UPLOAD_BANK_STATEMENT, {
            [this.$mixpanelPayload.ERROR_REASON]: err.message,
          });
          this.isPanelGlibConfirm = false;
          this.isSpinLoading = false;
        });
    },
    unWrapProxy(maybeRefOrReactive) {
      if (isRef(maybeRefOrReactive)) return maybeRefOrReactive.value || [];
      return maybeRefOrReactive ? toRaw(maybeRefOrReactive) : [];
    },
    handleDocActionSubmit() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MANUAL_BANK_STATEMENT_SUBMIT, {
        [this.$mixpanelPayload.KEY_MESSAGE]: `user click the submit btn with bank statement document: ${this.checKDocLength}`,
      });
      if (this.checKDocLength) {
        this.backToStep3();
      } else {
        this.isPanelGlibConfirm = true;
      }
    },
    getBankStatementStatusRetry() {
      this.isSpinLoadingLoanOffer = true;
      let retryCount = 0;
      const maxRetries = 6;
      const retryInterval = 10000;
      const checkStatus = () => {
        this.$store
          .dispatch('bankStatementStatus', {
            applicationId: this.applicationId,
          })
          .then((res) => {
            if (res?.hasRequiredMonthsBankStatement === 'true') {
              this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
                [this.$mixpanelPayload.RESPONSE]: res,
                [this.$mixpanelPayload.KEY_MESSAGE]: 're-try from the third party app',
              });
              this.isPanelGlibConfirm = false;
              this.isPanelNotSixMonthBank = false;
              this.notValidBankStatement = false;
              this.backToStep3();
              this.isSpinLoadingLoanOffer = false;
              this.$store.commit('SET_IS_BANK_STATEMENT_DOC_UPLOADED', true);
            } else {
              retryCount += 1;
              if (retryCount < maxRetries) {
                setTimeout(() => {
                  checkStatus();
                }, retryInterval);
              } else {
                this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
                  [this.$mixpanelPayload.RESPONSE]: res,
                  [this.$mixpanelPayload.KEY_MESSAGE]: 'Bank statement check after 6 retries.',
                });
                if (res.invalidBankStatement) {
                  this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MANUAL_POPUPS, {
                    [this.$mixpanelPayload.KEY_MESSAGE]: 'Verification failed.',
                  });
                  this.isPanelNotSixMonthBank = true;
                  this.notValidBankStatement = true;
                } else if (res?.hasRequiredMonthsBankStatement === '' && res?.processingType === 'manual') {
                  this.isPanelNotSixMonthBank = false;
                  this.notValidBankStatement = false;
                  this.isPanelBankStatementUnderReview = true;
                  this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MANUAL_POPUPS, {
                    [this.$mixpanelPayload.KEY_MESSAGE]: 'Bank statement review is in progress.',
                  });
                } else {
                  this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MANUAL_POPUPS, {
                    [this.$mixpanelPayload.KEY_MESSAGE]: 'bank statement doesnt cover 6 months',
                  });
                  this.isPanelNotSixMonthBank = true;
                  this.notValidBankStatement = false;
                }
                this.isPanelGlibConfirm = false;
                this.isSpinLoadingLoanOffer = false;
              }
            }
          })
          .catch((err) => {
            retryCount += 1;
            console.error('Error checking bank statement:', err);
            if (retryCount < maxRetries) {
              setTimeout(() => {
                checkStatus();
              }, retryInterval);
            } else {
              this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
                [this.$mixpanelPayload.RESPONSE]: err,
                [this.$mixpanelPayload.KEY_MESSAGE]: 'Bank statement check failed after 6 retries.',
              });
              this.isSpinLoadingLoanOffer = false;
              console.log('Bank statement check failed after 6 retries.');
            }
          });
      };
      checkStatus();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    getInstantVerification() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.isSpinLoading = true;
      this.$store
        .dispatch('createConsentOneMoney', {
        })
        .then((result) => {
          if (result?.status === "success") {
            window.microapps.openUrl({ url: result?.data?.webRedirectionUrl });
          }
          this.isSpinLoading = false;
        })
        .catch(() => {
          this.isSpinLoading = false;
        });
    },
    reUploadFun() {
      this.notValidBankStatement = false;
      this.isPanelNotSixMonthBank = false;
      this.isPanelGlibConfirm = false;
      this.requestMedia('Re-Upload', 'bank statement covers at least last 6 months');
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.pageVisible = false;
      } else {
        this.pageVisible = true;
        this.getBankStatementStatusRetry();
      }
    },
    reviewNoBankStatementFun() {
      this.isPanelBankStatementUnderReview = false;
      this.$store.commit('SET_IS_BANK_STATEMENT_DOC_UPLOADED', true);
      this.backToStep3();
    },
    startBankStatementPolling() {
      this.getBankStatementStatus('interval');
      this.checkStatusInterval = setInterval(() => {
        this.getBankStatementStatus('interval');
      }, 30000);
    },
    stopBankStatementPolling() {
      if (this.checkStatusInterval) {
        clearInterval(this.checkStatusInterval);
        this.checkStatusInterval = null;
      }
    },
  }
};
  </script>

  <style lang="scss" scoped></style>
